import api from '../config/api';

/**
 * Care Team API Service
 * Handles all care team related API calls
 */
export const careTeamService = {
  /**
   * Get public care team listing with pagination
   * @param {Object} params - Query parameters
   * @param {number} params.page - Page number (default: 1)
   * @param {number} params.per_page - Items per page (default: 6)
   * @returns {Promise} API response with care team data
   */
  async getPublicCareTeamList(params = {}) {
    try {
      const queryParams = {
        page: params.page || 1,
        per_page: params.per_page || 2,
        ...params
      };

      const response = await api.get('/care-team/public/list', {
        params: queryParams
      });

      return {
        success: true,
        data: response.data,
        error: null
      };
    } catch (error) {
      console.error('Error fetching care team list:', error);
      
      return {
        success: false,
        data: null,
        error: {
          message: error.response?.data?.message || error.message || 'Failed to fetch providers',
          status: error.response?.status || 500,
          details: error.response?.data || null
        }
      };
    }
  },

  /**
   * Get care team details by ID
   * @param {string} id - Care team member ID
   * @returns {Promise} API response with care team member details
   */
  async getCareTeamMember(id) {
    try {
      const response = await api.get(`/care-team/care-team/${id}`);
      
      return {
        success: true,
        data: response.data,
        error: null
      };
    } catch (error) {
      console.error('Error fetching care team member:', error);
      
      return {
        success: false,
        data: null,
        error: {
          message: error.response?.data?.message || error.message || 'Failed to fetch provider details',
          status: error.response?.status || 500,
          details: error.response?.data || null
        }
      };
    }
  }
};

export default careTeamService;

